import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  successTitleWorkItem: {
    id: 'frontbucket.jiraTab.createWorkItemFlag.successTitle',
    description:
      'The title of a flag which informs the user that a Jira work item was created successfully',
    defaultMessage: 'Work item successfully created!',
  },
  successDescriptionWorkItemSpaces: {
    id: 'frontbucket.jiraTab.createWorkItemFlag.successDescription.spaces',
    description:
      'A message which informs the user that the work item was created and in which space',
    defaultMessage:
      'The work item {issueKey} was successfully created in the {projectName} ({projectKey}) space.',
  },
  viewWorkItemLink: {
    id: 'frontbucket.jiraTab.createWorkItemSuccessFlag.viewWorkItemLink',
    description:
      'Text for a link to the Jira work item which was successfully created.',
    defaultMessage: 'View work item',
  },
});
